var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#a135bb}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m798.7 461.8c-55.3 86-113.6 169-174.1 249.9-49.1 64.5-119.8 148.5-214 250.9-9.2 10.2-22.5 12.2-34.8 7.1-15.4-7.1-22.5-24.5-15.4-40.9l139.3-317.5c1-3 2.1-5.1 2.1-8.2 0-11.2-9.3-20.4-20.5-20.4h-238.6c-4.1 0-8.2-1.1-11.3-3.1-9.2-6.2-12.3-18.4-6.1-28.7 55.3-84 113.6-165.9 174.1-244.7 48.1-63.5 119.8-145.4 213-245.8 9.2-9.2 22.5-12.3 34.8-6.1 15.3 7.1 22.5 25.6 15.3 40.9l-137.2 306.2c-1 3.1-2 5.1-2 8.2 0 11.3 9.2 20.5 20.4 20.5h238.6c4.1 0 8.2 1 11.3 3.1 9.2 6.1 11.3 19.4 5.1 28.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.05a0f32804527b9ad19dd44745b8d978.svg";
export { ForwardRef as ReactComponent };